module.exports = __webpack_public_path__ + "static/media/lunchMenu.3a902deb.pdf";